import React, { useEffect, useState } from 'react'
import WorkFlow from '../../../../../../libs/api/services/WorkFlow'

const DocumentsContext = React.createContext()

const resolveEventId = (event) => {
    if (!event) return undefined

    if (typeof event === 'string') return event

    const directCandidates = [
        event.id,
        event.Id,
        event.ID,
        event.eventId,
        event.EventId,
        event.workflowEventId,
        event.WorkflowEventId,
        event.workFlowEventId,
        event.WorkFlowEventId,
        event.wfEventId,
        event.WFEventId,
        event.historyId,
        event.HistoryId,
        event.workflowHistoryId,
        event.WorkflowHistoryId,
        event.wfEventHistoryId,
        event.WFEventHistoryId,
    ]

    const directMatch = directCandidates.find((candidate) => candidate != null && candidate !== '')
    if (directMatch) return directMatch

    const nestedCandidates = [
        event.wfEvent,
        event.WFEvent,
        event.event,
        event.Event,
        event.workflowEvent,
        event.WorkflowEvent,
        event.workFlowHistory,
        event.WorkFlowHistory,
        event.historyEntry,
        event.HistoryEntry,
    ]

    for (const nestedValue of nestedCandidates) {
        const nestedMatch = resolveEventId(nestedValue)
        if (nestedMatch) return nestedMatch
    }

    return undefined
}

export const DocumentsProvider = ({ event, defaultValue, children }) => {
    const [docs, setDocs] = useState(defaultValue ? defaultValue : [])
    useEffect(() => { setDocs(defaultValue) }, [defaultValue])

    const _handleSendToServer = async (file) => {
        const eventId = resolveEventId(event)
        if (!eventId) {
            throw new Error('Workflow event id is missing')
        }

        // var res = { ...file, fileName: file.name, status: 'Uploading' }
        // console.log('event',event.id)
        var res = await WorkFlow.UploadDocument(eventId, {
            document: {
                fileName: file.fileName,
                mimeType: file.mimeType,
                data: file.data
            }
        })
        return res ? 'Uploaded' : 'Failed'
    }

    const _handleBase64 = async (file) => {
        return await await new Promise((resolve) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {
                resolve(reader.result)
            }
        })
    }

    const _handleUploadFiles = async (files) => {
        var _docs = docs
        var _newdocs = []

        // Send to front end
        for (const file of files) {
            _newdocs.push({ document: { ...file, mimeType: file.type, fileName: file.name, status: 'Uploading', data: await _handleBase64(file) } })
            setDocs([..._docs, ..._newdocs])
        }
        // console.log([..._docs,..._newdocs])
        // Get base 64 / update status
        for (var _doc of _newdocs) {
            _doc.document.status = await _handleSendToServer(_doc.document)
            setDocs([..._docs, ..._newdocs])
        }
    }

    const _handleRemove = async (filesId) => {
        setDocs(docs.filter(f => f.document.id !== filesId))
        WorkFlow
            .RemoveFile(filesId)
    }
    const _handleGetDocument = async (filesId) => await WorkFlow
        .GetDocument(filesId)

    return (
        <DocumentsContext.Provider value={{
            documents: docs,
            uploadFiles: (files) => _handleUploadFiles(files),
            remove: _handleRemove,
            getFile: (id) => _handleGetDocument(id)
        }}>
            {children}
        </DocumentsContext.Provider>
    )
}

export default DocumentsContext